export const decodeSortQuery = <T extends string>(query: string) => ({
  prop: query.split(',').shift() as T,
  order: query.split(',').pop() as 'asc' | 'desc',
});
